'use client';

import React from 'react';
import { cn } from '../lib/utils';

export interface FieldLabelProps {
  children: React.ReactNode;
  /** Show a red asterisk to indicate the field is required */
  required?: boolean;
  /** HTML for attribute — links to the input's id */
  htmlFor?: string;
  className?: string;
}

/**
 * Shared form field label — replaces 64+ duplicate `FieldLabel` definitions
 * across the Statura Care dashboard.
 *
 * Default style: 11px uppercase tracking-wide slate-500 (matching the
 * existing pattern used site-wide).
 */
export function FieldLabel({ children, required = false, htmlFor, className }: FieldLabelProps) {
  return (
    <label
      htmlFor={htmlFor}
      className={cn('mb-1.5 block font-body text-eyebrow uppercase text-text-muted', className)}
    >
      {children}
      {required && (
        <span className="text-red-500 ml-0.5" aria-hidden="true">
          *
        </span>
      )}
    </label>
  );
}
